import React, {
  createContext,
  MutableRefObject,
  ReactNode,
  useContext,
  useRef
} from 'react'

import { type SessionResponse } from '@/ports'

type ContextType = {
  afterLogin: (session?: SessionResponse) => void
  setAfterLogin: (action: ((session?: SessionResponse) => void) | null) => void
  afterLoginRef: MutableRefObject<(() => void) | null>
}

const DSLoginContext = createContext<ContextType | undefined>(undefined)

interface DSLoginProviderProps {
  children: ReactNode
}

export const DSLoginProvider: React.FC<DSLoginProviderProps> = ({
  children
}) => {
  const afterLoginRef = useRef<((session?: SessionResponse) => void) | null>(
    null
  )
  const setAfterLogin = (action: (() => void) | null) => {
    afterLoginRef.current = action // this is wrong, it takes a snapshot of the action and creating a closure, effectively freezing the internal state
  }

  const afterLogin = (session?: SessionResponse) => {
    const action = afterLoginRef.current
    if (action) {
      action(session)
    }

    afterLoginRef.current = null
  }
  return (
    <DSLoginContext.Provider
      value={{ afterLogin, setAfterLogin, afterLoginRef }}
    >
      {children}
    </DSLoginContext.Provider>
  )
}

// WARNING: DON'T USE THIS ANYMORE see setAfterLogin
export const useDSLogin = (): ContextType => {
  const context = useContext(DSLoginContext)
  if (!context) {
    throw new Error('useDSLogin must be used within a DSLoginProvider')
  }
  return context
}
